import {createI18n} from 'vue-i18n';

import fr from './fr.json'
import en from './en.json'

const i18n = createI18n({
    locale: "fr", // set locale
    fallbackLocale: "fr",
    globalInjection: true,
    legacy: false,
    messages: { fr , en }, // set locale messages
  })
export default i18n;